import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiModulesService {
  private domain = environment.apiUrl.replace(/\/$/, '') + '/';
  public apiurl;
  private getHttpOptions() {
    const token = localStorage.getItem('token') || '';
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token);
    return { headers };
  }
  constructor(private http: HttpClient) { }
  private handleError(error: any) {
    return throwError(error);
  }

  get(type: any): Observable<any> {
    this.apiurl = this.domain + `api/${type}`;
    return this.http
      .get<any>(this.apiurl, this.getHttpOptions())
      .pipe(tap(), catchError(this.handleError));
  }
  getweb(type: any): Observable<any> {
    this.apiurl = this.domain + `${type}`;
    return this.http
      .get<any>(this.apiurl, this.getHttpOptions())
      .pipe(tap(), catchError(this.handleError));
  }

  // add(params: any, type: any): Observable<any> {
  //   this.apiurl = this.domain + `api/${type}`;
  //   return this.http
  //     .post<any>(this.apiurl, params, this.getHttpOptions())
  //     .pipe(tap(), catchError(this.handleError));
  // }


  add(params: any, type: any): Observable<any> {

  this.apiurl = this.domain + `api/${type}`;

  // FormData check
  const options = params instanceof FormData
    ? {}
    : this.getHttpOptions();

  return this.http
    .post<any>(this.apiurl, params, options)
    .pipe(
      tap(),
      catchError(this.handleError)
    );
}

  edit(params: any, type: any): Observable<any> {
    this.apiurl = this.domain + `api/${type}`;
    return this.http
      .post<any>(this.apiurl, params, this.getHttpOptions())
      .pipe(tap(), catchError(this.handleError));

  }

  update(user: any, type): Observable<any> {
    this.apiurl = this.domain + `api/${type}`;
    const url = `${this.apiurl}/${user.id}`;
    return this.http.put<any>(url, user, this.getHttpOptions()).pipe(
      map(() => user),
      catchError(this.handleError)
    );
  }

  list(method: any, params: any): Observable<any> {
    this.apiurl = this.domain + `api/${method}`;
    return this.http
      .post<any>(this.apiurl, params, this.getHttpOptions())
      .pipe(tap(), catchError(this.handleError));

  }

}
